let federationConfigPath = "default";
if (require
    // @ts-ignore this is webpack stuff
    .context("../federations/", true)
    .keys()
    .some((x) => x.includes(process.env.VUE_APP_COUNTRY))) {
    federationConfigPath = process.env.VUE_APP_COUNTRY;
}
const ConfigImport = require("@/federations/" + federationConfigPath).default;
export default Object.freeze(new ConfigImport());
